import React from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import LabelR from '../../../../components/Simple/LabelR';
import { BoxWithTitle } from '../../../../components/common';
import { updateLegalRepresentative } from '../../../../redux/actions/ReferralActions';
import { getLegalRepresentative } from '../../../../redux/reducers/ReferralReducer';
import StepsFooter from '../steps/StepsFooter';
import { getValidationSchema } from '../../../../utils/Functions';

const OlaClickLegalRepresentativeStep = (props) => {
  const { t, hasPrevious, handlePrevStep, handleNextStep, lastStep, activeStep, updateLegalRepresentative, legalRepresentative, paramsForm, country } = props;
  const validationSchema = getValidationSchema(country, t).STEP_1;

  // eslint-disable-next-line no-unused-vars
  const handleSubmit = (values, actions) => {
    updateLegalRepresentative(values);
    handleNextStep();
  };

  const footerProps = {
    hasPrevious,
    handlePrevStep,
    lastStep,
    activeStep,
    t,
  };

  const initialValues = {
    fullName: legalRepresentative.fullName || '',
    rfc: legalRepresentative.rfc || '',
    email: legalRepresentative.email || '',
    fullAddress: legalRepresentative.fullAddress || '',
  };

  return (
    <Formik
      onSubmit={(values, actions) => {
        handleSubmit(values, actions);
      }}
      enableReinitialize
      validationSchema={validationSchema}
      initialValues={initialValues}
    >
      {({ errors, touched, isSubmitting }) => (
        <Form>
          <BoxWithTitle title={t('labelLegalRepresentativeInformation')}>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group form-item">
                  <LabelR htmlFor={paramsForm.fullName.name}>{t(paramsForm.fullName.labelText)}</LabelR>
                  <Field
                    type={paramsForm.fullName.name}
                    id={paramsForm.fullName.name}
                    name={paramsForm.fullName.name}
                    className={`form-control ${errors.fullName && touched.fullName ? 'is-invalid' : ''}`}
                    placeholder={t(paramsForm.fullName.placeholder)}
                  />
                  <ErrorMessage name={paramsForm.fullName.name} component="div" className="invalid-feedback" />
                </div>
                <div className="form-group form-item">
                  <LabelR htmlFor={paramsForm.documentType.htmlFor}>{t(paramsForm.documentType.labelText)}</LabelR>
                  <Field
                    type={paramsForm.documentType.type}
                    id={paramsForm.documentType.id}
                    name={paramsForm.documentType.name}
                    className={`form-control ${errors.rfc && touched.rfc ? 'is-invalid' : ''}`}
                    placeholder={t(paramsForm.documentType.placeholder)}
                  />
                  <ErrorMessage name={paramsForm.documentType.name} component="div" className="invalid-feedback" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group form-item">
                  <LabelR htmlFor={paramsForm.email.htmlFor}>{t(paramsForm.email.labelText)}</LabelR>
                  <Field
                    type={paramsForm.email.type}
                    name={paramsForm.email.name}
                    className={`form-control ${errors.email && touched.email ? 'is-invalid' : ''}`}
                    placeholder={t(paramsForm.email.placeholder)}
                  />
                  <ErrorMessage name={paramsForm.email.name} component="div" className="invalid-feedback" />
                </div>
                <div className="form-group form-item">
                  <LabelR htmlFor={paramsForm.fullAddress.htmlFor}>{t(paramsForm.fullAddress.labelText)}</LabelR>
                  <Field
                    type={paramsForm.fullAddress.type}
                    id={paramsForm.fullAddress.id}
                    name={paramsForm.fullAddress.name}
                    className={`form-control ${errors.fullAddress && touched.fullAddress ? 'is-invalid' : ''}`}
                    placeholder={t(paramsForm.fullAddress.placeholder)}
                  />
                  <ErrorMessage name={paramsForm.fullAddress.name} component="div" className="invalid-feedback" />
                </div>
              </div>
            </div>
          </BoxWithTitle>
          <StepsFooter {...footerProps} isSubmitting={isSubmitting} />
        </Form>
      )}
    </Formik>
  );
};

const mapStateToProps = (state) => {
  return {
    legalRepresentative: getLegalRepresentative(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateLegalRepresentative,
    },
    dispatch
  );

export default compose(withNamespaces(), connect(mapStateToProps, mapDispatchToProps))(OlaClickLegalRepresentativeStep);
